module.exports = __webpack_public_path__ + "media/assets/ApproveCheckMark-a6718277215d3b8a897e96a75ea87627.svg";